"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _Theme = _interopRequireDefault(require("../Theme"));
var _sliderButton = _interopRequireDefault(require("./sliderButton.proptypes"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/* eslint-disable jsx-a11y/click-events-have-key-events */

var StyledSliderButton = (0, _styledComponents.default)(function (_ref) {
  var direction = _ref.direction,
    className = _ref.className,
    handleClick = _ref.handleClick,
    icon = _ref.icon,
    tabIndex = _ref.tabIndex;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: className,
    tabIndex: tabIndex,
    onClick: handleClick,
    direction: direction,
    role: "button"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    icon: icon,
    fontsize: "titleNormal",
    accessible: false
  }));
}).withConfig({
  displayName: "SliderButton__StyledSliderButton",
  componentId: "sc-g8qgwq-0"
})(["display:flex;align-items:center;justify-content:center;width:32px;height:32px;background:", ";box-shadow:0px 2px 4px rgba(0,0,0,0.25);border-radius:4px;cursor:pointer;"], function (props) {
  return props.background ? props.theme.backgroundColor[props.background] : props.theme.backgroundColor.default;
});
var SliderButton = function SliderButton(_ref2) {
  var handleClick = _ref2.handleClick,
    theme = _ref2.theme,
    icon = _ref2.icon,
    accessible = _ref2.accessible,
    background = _ref2.background;
  var tabIndex = !accessible ? '-1' : '0';
  var themeContext = (0, _react.useContext)(_styledComponents.ThemeContext);
  var getMain = function getMain() {
    return /*#__PURE__*/_react.default.createElement(StyledSliderButton, {
      tabIndex: tabIndex,
      handleClick: handleClick,
      icon: icon,
      background: background,
      theme: themeContext
    });
  };
  return themeContext ? getMain() : /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, getMain());
};
SliderButton.propTypes = _sliderButton.default.PropTypes;
SliderButton.defaultProps = _sliderButton.default.DefaultProps;
var _default = SliderButton;
exports.default = _default;